/**
 * This module is used to language translations.
 * The translations are saved in a json file in /src/app/assets/i18n directory
 * Docs: https://www.codeandweb.com/babeledit/tutorials/how-to-translate-your-angular7-app-with-ngx-translate
 */
import { NgModule } from '@angular/core';
import {HttpBackend, HttpClient} from '@angular/common/http';

// import ngx-translate and the http loader
import {
    MissingTranslationHandler,
    TranslateLoader,
    TranslateModule,
    TranslateService
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {MissingTranslationHelper} from './missing-translation.module';

// ngx-translate - required for AOT compilation
/*export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}*/

export function HttpLoaderFactory(httpBackend: HttpBackend): TranslateHttpLoader {
    return new TranslateHttpLoader(new HttpClient(httpBackend))

}

@NgModule({
    declarations: [],
    imports: [
        TranslateModule.forRoot({
            missingTranslationHandler: {provide: MissingTranslationHandler, useClass: MissingTranslationHelper},
            useDefaultLang: false,
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpBackend]
            }
        })
    ],
    exports: [
        TranslateModule
    ],
})
export class LanguageTranslationModule {
    constructor(
        private translate: TranslateService,
    ) {
        // Gets Default language from browser if available, otherwise set Italian as default
        this.translate.addLangs(['en', 'it']);
        this.translate.setDefaultLang('it');
        const browserLang = this.translate.getBrowserLang();
        this.translate.use(browserLang.match(/en|it/) ? browserLang : 'it');
    }
}
